'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fp = require('lodash/fp');

var _fp2 = _interopRequireDefault(_fp);

var _FilterCollection = require('../../Filters/FilterCollection');

var _FilterCollection2 = _interopRequireDefault(_FilterCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _FilterCollection2.default)('homes')('Sqft', {
  filter: function filter(home, _ref) {
    var values = _ref.values;

    if (values.length === 0) {
      return true;
    }

    var result = values.reduce(function (include, value) {
      if (include) {
        return true;
      }

      var start = _fp2.default.get('value.start', value);
      var end = _fp2.default.get('value.end', value);

      return home.sqft >= start && home.sqft <= end;
    }, false);

    return result;
  },
  collectValues: function collectValues(homes, _ref2) {
    var config = _ref2.config;

    var increment = _fp2.default.get('increment', config);
    var start = _fp2.default.get('start', config);
    var list = _fp2.default.map('sqft', homes);

    var ranges = [];
    var max = _fp2.default.max(list);

    var startVal = start;
    var sqftFilter = function sqftFilter(val) {
      return function (sqft) {
        if (sqft >= val && sqft <= val + increment) {
          return true;
        }
        return false;
      };
    };
    while (startVal < max) {
      var matched = _fp2.default.filter(sqftFilter(startVal), list);
      if (matched.length > 0) {
        var value = {
          start: startVal,
          end: startVal + increment
        };
        var range = {
          value: value
        };
        ranges.push(range);
      }
      startVal += increment;
    }
    return ranges;
  },

  labelRender: function labelRender(_ref3) {
    var value = _ref3.value;
    return value.start + ' - ' + value.end + ' Sqft';
  },
  increment: 1500,
  start: 1000
});


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Homes/filters/Sqft.js
// module id = 975
// module chunks = 0